interface IProfileHelper {
    mark(point: string): void;
    end(): void;
}

export class ProfileHelper implements IProfileHelper {
    private static enabled = false;

    private label: string;
    private lastMark: string;

    constructor(label: string) {
        this.label = `${label}-${performance.now()}`;
        performance.mark(`${this.label}-start`);
        this.lastMark = `${this.label}-start`;
    }

    public static start(label: string) {
        if (!ProfileHelper.enabled) {
            return ProfileHelper.noopInstance;
        }
        return new ProfileHelper(label);
    }

    public mark(point: string) {
        const name = `${this.label}-${point}`;
        performance.mark(name);
        performance.measure(`${name}-measure`, this.lastMark, name);
        this.lastMark = name;
    }

    public end() {
        performance.mark(`${this.label}-end`);
        performance.measure(`${this.label}-total`, `${this.label}-start`, `${this.label}-end`);

        performance.clearMarks(`${this.label}-*`);
        performance.clearMeasures(`${this.label}-*`);
    }

    //singleton noop to avoid allocations
    private static noopInstance: IProfileHelper = {
        mark: (_: string) => {},
        end: () => {},
    };

    // runtime toggle
    public static enable() {
        ProfileHelper.enabled = true;
        console.log('ProfileHelper enabled');
    }

    public static disable() {
        ProfileHelper.enabled = false;
        console.log('ProfileHelper disabled');
    }
}
